export default __webpack_public_path__ + "static/media/pt-icon.e1c28771.webp";